export default __webpack_public_path__ + "dfe0cb8ba9879b2e7bce4986a20cf202.png";